module.exports = __webpack_public_path__ + "img/movie.1b6d861c.svg";